module.exports = __webpack_public_path__ + "static/L2_visual_2_2_eg-976ee7fb1d6bac92e86aac7a79633b09.png";